module.exports = __webpack_public_path__ + "img/box9-08.6fc5cc42.png";